import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import f from "./ImagePreview.js";
import { imagePreviewSharedProps as h } from "./interface.js";
import { createInjectionKey as g } from "../../_utils/vue/create-injection-key.js";
import p from "../../_mixins/use-config.js";
import { createId as w } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { defineComponent as P, getCurrentInstance as x, provide as T, h as b } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as I, toRef as S } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const y = g("n-image-group"), C = h, O = P({
  name: "ImageGroup",
  props: C,
  setup(o) {
    let s;
    const {
      mergedClsPrefixRef: v
    } = p(o), d = `c${w()}`, i = x(), n = I(null), l = (e) => {
      var r;
      s = e, (r = n.value) === null || r === void 0 || r.setPreviewSrc(e);
    };
    function m(e) {
      var r, a;
      if (!(i != null && i.proxy))
        return;
      const t = i.proxy.$el.parentElement.querySelectorAll(`[data-group-id=${d}]:not([data-error=true])`);
      if (!t.length)
        return;
      const u = Array.from(t).findIndex((c) => c.dataset.previewSrc === s);
      ~u ? l(t[(u + e + t.length) % t.length].dataset.previewSrc) : l(t[0].dataset.previewSrc), e === 1 ? (r = o.onPreviewNext) === null || r === void 0 || r.call(o) : (a = o.onPreviewPrev) === null || a === void 0 || a.call(o);
    }
    return T(y, {
      mergedClsPrefixRef: v,
      setPreviewSrc: l,
      setThumbnailEl: (e) => {
        var r;
        (r = n.value) === null || r === void 0 || r.setThumbnailEl(e);
      },
      toggleShow: () => {
        var e;
        (e = n.value) === null || e === void 0 || e.toggleShow();
      },
      groupId: d,
      renderToolbarRef: S(o, "renderToolbar")
    }), {
      mergedClsPrefix: v,
      previewInstRef: n,
      next: () => {
        m(1);
      },
      prev: () => {
        m(-1);
      }
    };
  },
  render() {
    return b(f, {
      theme: this.theme,
      themeOverrides: this.themeOverrides,
      clsPrefix: this.mergedClsPrefix,
      ref: "previewInstRef",
      onPrev: this.prev,
      onNext: this.next,
      showToolbar: this.showToolbar,
      showToolbarTooltip: this.showToolbarTooltip,
      renderToolbar: this.renderToolbar
    }, this.$slots);
  }
});
export {
  O as default,
  y as imageGroupInjectionKey,
  C as imageGroupProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/image/src/ImageGroup.js
// module id = 919
// module chunks = 41